<!--
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
-->
<template>
  <!--
    This example requires updating your template:

    ```
    <html class="h-full bg-white">
    <body class="h-full overflow-hidden">
    ```
  -->
  <div class="flex h-full">
    <!-- Static sidebar for desktop -->
    <div class="flex w-64 flex-col">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex min-h-0 flex-1 flex-col border-r border-gray-200 bg-gray-100">
        <div class="flex flex-1 flex-col overflow-y-auto pt-5 pb-4">
          <div class="flex flex-shrink-0 items-center px-4">
            <img
              class="h-8 w-auto"
              src="https://tailwindui.com/img/logos/mark.svg?color=pink&shade=500"
              alt="Your Company">
          </div>
          <nav
            class="mt-5 flex-1"
            aria-label="Sidebar">
            <div class="space-y-1 px-2">
              <a
                v-for="item in navigation"
                :key="item.name"
                :href="item.href"
                :class="[item.current ? 'bg-gray-200 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md']"
                :aria-current="item.current ? 'page' : undefined">
                <component
                  :is="item.icon"
                  :class="[item.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 flex-shrink-0 h-6 w-6']"
                  aria-hidden="true" />
                {{ item.name }}
              </a>
            </div>
            <hr
              class="my-5 border-t border-gray-200"
              aria-hidden="true">
            <div class="flex-1 space-y-1 px-2">
              <a
                v-for="item in secondaryNavigation"
                :key="item.name"
                :href="item.href"
                class="group flex items-center rounded-md px-2 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900">
                <component
                  :is="item.icon"
                  class="mr-3 h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                  aria-hidden="true" />
                {{ item.name }}
              </a>
            </div>
          </nav>
        </div>
        <div class="flex flex-shrink-0 border-t border-gray-200 p-4">
          <a
            href="#"
            class="group block w-full flex-shrink-0">
            <div class="flex items-center">
              <div>
                <img
                  class="inline-block h-9 w-9 rounded-full"
                  :src="user.imageUrl"
                  alt="">
              </div>
              <div class="ml-3">
                <p class="text-sm font-medium text-gray-700 group-hover:text-gray-900">{{ user.name }}</p>
                <p class="text-xs font-medium text-gray-500 group-hover:text-gray-700">View profile</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="flex min-w-0 flex-1 flex-col overflow-hidden">
    <div class="lg:hidden">
      <div class="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-1.5">
        <div>
          <img
            class="h-8 w-auto"
            src="https://tailwindui.com/img/logos/mark.svg?color=pink&shade=500"
            alt="Your Company">
        </div>
        <div>
          <button
            type="button"
            class="-mr-3 inline-flex h-12 w-12 items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-pink-600"
            @click="sidebarOpen = true">
            <span class="sr-only">Open sidebar</span>
            <Bars3Icon
              class="h-6 w-6"
              aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
    <div class="relative z-0 flex flex-1 overflow-hidden">
      <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none xl:order-last">
        <!-- Breadcrumb -->
        <nav
          class="flex items-start px-4 py-3 sm:px-6 lg:px-8 xl:hidden"
          aria-label="Breadcrumb">
          <a
            href="#"
            class="inline-flex items-center space-x-3 text-sm font-medium text-gray-900">
            <ChevronLeftIcon
              class="-ml-2 h-5 w-5 text-gray-400"
              aria-hidden="true" />
            <span>Directory</span>
          </a>
        </nav>

        <article data-file="Test2.vue">
          <div class="xl:col-span-2 xl:border-r xl:border-gray-200 xl:pr-8">
            <div>
              <div>
                <div class="md:flex md:items-center md:justify-between md:space-x-4 xl:border-b xl:pb-6">
                  <div>
                    <h1 class="text-2xl font-bold text-gray-900">
                      ARIA attribute misspelled
                    </h1>
                    <p class="mt-2 text-sm text-gray-500">
                      #400 opened by
                      {{ ' ' }}
                      <a
                        href="#"
                        class="font-medium text-gray-900">Hilary Mahy</a>
                      {{ ' ' }}
                      in
                      {{ ' ' }}
                      <a
                        href="#"
                        class="font-medium text-gray-900">Customer Portal</a>
                    </p>
                  </div>
                  <div class="mt-4 flex space-x-3 md:mt-0">
                    <button
                      type="button"
                      class="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2">
                      <PencilIcon
                        class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                        aria-hidden="true" />
                      <span>Edit</span>
                    </button>
                    <button
                      type="button"
                      class="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2">
                      <BellIcon
                        class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                        aria-hidden="true" />
                      <span>Subscribe</span>
                    </button>
                  </div>
                </div>
                <aside class="mt-8 xl:hidden">
                  <h2 class="sr-only">
                    Details
                  </h2>
                  <div class="space-y-5">
                    <div class="flex items-center space-x-2">
                      <LockOpenIcon
                        class="h-5 w-5 text-green-500"
                        aria-hidden="true" />
                      <span class="text-sm font-medium text-green-700">Open Issue</span>
                    </div>
                    <div class="flex items-center space-x-2">
                      <ChatBubbleLeftEllipsisIcon
                        class="h-5 w-5 text-gray-400"
                        aria-hidden="true" />
                      <span class="text-sm font-medium text-gray-900">4 comments</span>
                    </div>
                    <div class="flex items-center space-x-2">
                      <CalendarIcon
                        class="h-5 w-5 text-gray-400"
                        aria-hidden="true" />
                      <span class="text-sm font-medium text-gray-900">Created on <time datetime="2020-12-02">Dec 2, 2020</time></span>
                    </div>
                  </div>
                  <div class="mt-6 space-y-8 border-t border-b border-gray-200 py-6">
                    <div>
                      <h2 class="text-sm font-medium text-gray-500">
                        Assignees
                      </h2>
                      <ul
                        role="list"
                        class="mt-3 space-y-3">
                        <li class="flex justify-start">
                          <a
                            href="#"
                            class="flex items-center space-x-3">
                            <div class="flex-shrink-0">
                              <img
                                class="h-5 w-5 rounded-full"
                                src="https://images.unsplash.com/photo-1520785643438-5bf77931f493?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80"
                                alt="">
                            </div>
                            <div class="text-sm font-medium text-gray-900">Eduardo Benz</div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <h2 class="text-sm font-medium text-gray-500">
                        Tags
                      </h2>
                      <ul
                        role="list"
                        class="mt-2 leading-8">
                        <li class="inline">
                          <a
                            href="#"
                            class="relative inline-flex items-center rounded-full border border-gray-300 px-3 py-0.5">
                            <div class="absolute flex flex-shrink-0 items-center justify-center">
                              <span
                                class="h-1.5 w-1.5 rounded-full bg-rose-500"
                                aria-hidden="true" />
                            </div>
                            <div class="ml-3.5 text-sm font-medium text-gray-900">Bug</div>
                          </a>
                          {{ ' ' }}
                        </li>
                        <li class="inline">
                          <a
                            href="#"
                            class="relative inline-flex items-center rounded-full border border-gray-300 px-3 py-0.5">
                            <div class="absolute flex flex-shrink-0 items-center justify-center">
                              <span
                                class="h-1.5 w-1.5 rounded-full bg-indigo-500"
                                aria-hidden="true" />
                            </div>
                            <div class="ml-3.5 text-sm font-medium text-gray-900">Accessibility</div>
                          </a>
                          {{ ' ' }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </aside>
                <div class="py-3 xl:pt-6 xl:pb-0">
                  <h2 class="sr-only">
                    Description
                  </h2>
                  <div class="prose max-w-none">
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita, hic? Commodi cumque similique id tempora molestiae deserunt at suscipit, dolor voluptatem, numquam, harum consequatur laboriosam voluptas tempore aut voluptatum alias?</p>
                    <ul role="list">
                      <li>Tempor ultrices proin nunc fames nunc ut auctor vitae sed. Eget massa parturient vulputate fermentum id facilisis nam pharetra. Aliquet leo tellus.</li>
                      <li>Turpis ac nunc adipiscing adipiscing metus tincidunt senectus tellus.</li>
                      <li>Semper interdum porta sit tincidunt. Dui suspendisse scelerisque amet metus eget sed. Ut tellus in sed dignissim.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <section
              aria-labelledby="activity-title"
              class="mt-8 xl:mt-10">
              <div>
                <div class="divide-y divide-gray-200">
                  <div class="pb-4">
                    <h2
                      id="activity-title"
                      class="text-lg font-medium text-gray-900">
                      Activity
                    </h2>
                  </div>
                  <div class="pt-6">
                    <!-- Activity feed-->
                    <div class="flow-root">
                      <ul
                        role="list"
                        class="-mb-8">
                        <li
                          v-for="(item, itemIdx) in activity"
                          :key="item.id">
                          <div class="relative pb-8">
                            <span
                              v-if="itemIdx !== activity.length - 1"
                              class="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200"
                              aria-hidden="true" />
                            <div class="relative flex items-start space-x-3">
                              <template v-if="item.type === 'comment'">
                                <div class="relative">
                                  <img
                                    class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-400 ring-8 ring-white"
                                    :src="item.imageUrl"
                                    alt="">

                                  <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
                                    <ChatBubbleLeftEllipsisIcon
                                      class="h-5 w-5 text-gray-400"
                                      aria-hidden="true" />
                                  </span>
                                </div>
                                <div class="min-w-0 flex-1">
                                  <div>
                                    <div class="text-sm">
                                      <a
                                        :href="item.person.href"
                                        class="font-medium text-gray-900">{{ item.person.name }}</a>
                                    </div>
                                    <p class="mt-0.5 text-sm text-gray-500">
                                      Commented {{ item.date }}
                                    </p>
                                  </div>
                                  <div class="mt-2 text-sm text-gray-700">
                                    <p>{{ item.comment }}</p>
                                  </div>
                                </div>
                              </template>
                              <template
                                v-else-if="item.type === 'assignment'"
                                condition="item.type === 'assignment'">
                                <div>
                                  <div class="relative px-1">
                                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                                      <UserCircleIconMini
                                        class="h-5 w-5 text-gray-500"
                                        aria-hidden="true" />
                                    </div>
                                  </div>
                                </div>
                                <div class="min-w-0 flex-1 py-1.5">
                                  <div class="text-sm text-gray-500">
                                    <a
                                      :href="item.person.href"
                                      class="font-medium text-gray-900">{{ item.person.name }}</a>
                                    {{ ' ' }}
                                    assigned
                                    {{ ' ' }}
                                    <a
                                      :href="item.assigned.href"
                                      class="font-medium text-gray-900">{{ item.assigned.name }}</a>
                                    {{ ' ' }}
                                    <span class="whitespace-nowrap">{{ item.date }}</span>
                                  </div>
                                </div>
                              </template>
                              <template v-else>
                                <div>
                                  <div class="relative px-1">
                                    <div class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                                      <TagIcon
                                        class="h-5 w-5 text-gray-500"
                                        aria-hidden="true" />
                                    </div>
                                  </div>
                                </div>
                                <div class="min-w-0 flex-1 py-0">
                                  <div class="text-sm leading-8 text-gray-500">
                                    <span class="mr-0.5">
                                      <a
                                        :href="item.person.href"
                                        class="font-medium text-gray-900">{{ item.person.name }}</a>
                                      {{ ' ' }}
                                      added tags
                                    </span>
                                    {{ ' ' }}
                                    <span class="mr-0.5">
                                      <template
                                        v-for="tag in item.tags"
                                        :key="tag.name">
                                        <a
                                          :href="tag.href"
                                          class="relative inline-flex items-center rounded-full border border-gray-300 px-3 py-0.5 text-sm">
                                          <span class="absolute flex flex-shrink-0 items-center justify-center">
                                            <span
                                              :class="[tag.color, 'h-1.5 w-1.5 rounded-full']"
                                              aria-hidden="true" />
                                          </span>
                                          <span class="ml-3.5 font-medium text-gray-900">{{ tag.name }}</span>
                                        </a>
                                        {{ ' ' }}
                                      </template>
                                    </span>
                                    <span class="whitespace-nowrap">{{ item.date }}</span>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="mt-6">
                      <div class="flex space-x-3">
                        <div class="flex-shrink-0">
                          <div class="relative">
                            <img
                              class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-400 ring-8 ring-white"
                              src="https://images.unsplash.com/photo-1517365830460-955ce3ccd263?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80"
                              alt="">

                            <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
                              <ChatBubbleLeftEllipsisIcon
                                class="h-5 w-5 text-gray-400"
                                aria-hidden="true" />
                            </span>
                          </div>
                        </div>
                        <div class="min-w-0 flex-1">
                          <form action="#">
                            <div>
                              <label
                                for="comment"
                                class="sr-only">Comment</label>
                              <textarea
                                id="comment"
                                name="comment"
                                rows="3"
                                class="block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-900 focus:ring-gray-900 sm:text-sm"
                                placeholder="Leave a comment" />
                            </div>
                            <div class="mt-6 flex items-center justify-end space-x-4">
                              <button
                                type="button"
                                class="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2">
                                <CheckCircleIcon
                                  class="-ml-1 mr-2 h-5 w-5 text-green-500"
                                  aria-hidden="true" />
                                <span>Close issue</span>
                              </button>
                              <button
                                type="submit"
                                class="inline-flex items-center justify-center rounded-md border border-transparent bg-gray-900 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2">
                                Comment
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </article>
      </main>
      <aside class="hidden w-96 flex-shrink-0 border-r border-gray-200 xl:order-first xl:flex xl:flex-col">
        <div class="px-6 pt-6 pb-4">
          <h2 class="text-lg font-medium text-gray-900">
            Directory
          </h2>
          <p class="mt-1 text-sm text-gray-600">
            Search directory of 3,018 employees
          </p>
          <form
            class="mt-6 flex space-x-4"
            action="#">
            <div class="min-w-0 flex-1">
              <label
                for="search"
                class="sr-only">Search</label>
              <div class="relative rounded-md shadow-sm">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <MagnifyingGlassIcon
                    class="h-5 w-5 text-gray-400"
                    aria-hidden="true" />
                </div>
                <input
                  id="search"
                  type="search"
                  name="search"
                  class="block w-full rounded-md border-gray-300 pl-10 focus:border-pink-500 focus:ring-pink-500 sm:text-sm"
                  placeholder="Search">
              </div>
            </div>
            <button
              type="submit"
              class="inline-flex justify-center rounded-md border border-gray-300 bg-white px-3.5 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2">
              <FunnelIcon
                class="h-5 w-5 text-gray-400"
                aria-hidden="true" />
              <span class="sr-only">Search</span>
            </button>
          </form>
        </div>
        <!-- Directory list -->
        <nav
          class="min-h-0 flex-1 overflow-y-auto"
          aria-label="Directory">
          <div
            v-for="letter in Object.keys(directory)"
            :key="letter"
            class="relative">
            <div class="sticky top-0 z-10 border-t border-b border-gray-200 bg-gray-50 px-6 py-1 text-sm font-medium text-gray-500">
              <h3>{{ letter }}</h3>
            </div>
            <ul
              role="list"
              class="relative z-0 divide-y divide-gray-200">
              <li
                v-for="person in directory[letter]"
                :key="person.id">
                <div class="relative flex items-center space-x-3 px-6 py-5 focus-within:ring-2 focus-within:ring-inset focus-within:ring-pink-500 hover:bg-gray-50">
                  <div class="flex-shrink-0">
                    <img
                      class="h-10 w-10 rounded-full"
                      :src="person.imageUrl"
                      alt="">
                  </div>
                  <div class="min-w-0 flex-1">
                    <a
                      href="#"
                      class="focus:outline-none">
                      <!-- Extend touch target to entire panel -->
                      <span
                        class="absolute inset-0"
                        aria-hidden="true" />
                      <p class="text-sm font-medium text-gray-900">{{ person.name }}</p>
                      <p class="truncate text-sm text-gray-500">{{ person.role }}</p>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </aside>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import {
  CalendarIcon,
  CogIcon,
  HomeIcon,
  MapIcon,
  UserGroupIcon,
} from '@heroicons/vue/24/outline';

const user = {
  name: 'Tom Cook',
  imageUrl:
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
};

const sidebarOpen = ref(false);
</script>
